import ModalRating from "../modals/ModalRating";

const ImportModals = () => {
    return (
        <div id={'base-box-all-modals'}>
        	<ModalRating />
        </div>
    );
}

export default ImportModals;
